import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal used in the hero.
export const MaskLines = ({ lines, className = "", lineClassName = "", start = false }) => (
  <span className={className} aria-label={lines.join(" ")}>
    {lines.map((line, i) => (
      <span key={i} className="text-reveal-line" aria-hidden="true">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : {}}
          transition={{
            duration: 0.9,
            delay: 0.25 + i * 0.12,
            ease: [0.16, 1, 0.3, 1],
          }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
